<template>
  <sub-page :title="title">
    <div class="doc-page">
      <div class="doc-intro" v-if="intro">{{ intro }}</div>

      <div class="doc-section" v-for="(sec, i) in sections" :key="i">
        <div class="section-title">{{ i + 1 }}. {{ sec.title }}</div>
        <div class="section-para" v-for="(p, j) in sec.paras" :key="j">{{ p }}</div>
        <!-- 清单/列表 -->
        <ul class="section-list" v-if="sec.list">
          <li v-for="(li, k) in sec.list" :key="k">{{ li }}</li>
        </ul>
        <!-- 表格类内容（第三方共享清单） -->
        <table class="section-table" v-if="sec.table">
          <thead>
            <tr><th v-for="(h, hi) in sec.table.head" :key="hi">{{ h }}</th></tr>
          </thead>
          <tbody>
            <tr v-for="(row, ri) in sec.table.rows" :key="ri">
              <td v-for="(c, ci) in row" :key="ci">{{ c }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'DocPage',
  components: { SubPage },
  computed: {
    title() {
      return (this.$route.meta && this.$route.meta.title) || ''
    },
    intro() {
      return this.$route.meta && this.$route.meta.intro
    },
    sections() {
      return (this.$route.meta && this.$route.meta.sections) || []
    }
  }
}
</script>

<style scoped>
.doc-page {
  min-height: 100%;
  background: #fff;
  padding: calc(40 * var(--w)) calc(60 * var(--w)) calc(80 * var(--w));
}
.doc-intro {
  margin-top: calc(24 * var(--w));
  font-size: calc(34 * var(--w));
  color: #666;
  line-height: 1.8;
}
.doc-section {
  margin-top: calc(48 * var(--w));
}
.section-title {
  font-size: calc(38 * var(--w));
  font-weight: bold;
  color: #1A1A1A;
  line-height: 1.5;
}
.section-para {
  margin-top: calc(20 * var(--w));
  font-size: calc(34 * var(--w));
  color: #666;
  line-height: 1.8;
}
.section-list {
  margin-top: calc(16 * var(--w));
  padding-left: calc(44 * var(--w));
}
.section-list li {
  font-size: calc(34 * var(--w));
  color: #666;
  line-height: 1.8;
}
/* 表格 */
.section-table {
  width: 100%;
  margin-top: calc(24 * var(--w));
  border-collapse: collapse;
  font-size: calc(30 * var(--w));
}
.section-table th,
.section-table td {
  border: 1px solid #E3E5E8;
  padding: calc(18 * var(--w)) calc(20 * var(--w));
  color: #666;
  line-height: 1.5;
  text-align: left;
  vertical-align: top;
}
.section-table th {
  background: #F5F8FB;
  color: #333;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/pages/DocPage.vue